import { XMarkIcon } from "@heroicons/react/24/outline";

export default function AdminContactTable(props) {
  const {
    contactList,
    handleSelectContact,
    handleDeleteBindedContact,
    selectedContact,
    isCheckbox = true,
    isBinded = false,
  } = props;

  return (
    <>
      <div className="mt-[12px] h-[12.6rem] block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead className="top-0 sticky">
            <tr className="border border-[#dddddd]" key={0}>
              <th className="font-normal w-12 p-2 bg-[#f2f2f4] border border-[#dddddd]">
                선택
              </th>
              <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                번호
              </th>
              <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                소속
              </th>
              <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                성명
              </th>
              <th className="font-normal p-2 bg-[#f2f2f4] border border-[#dddddd]">
                휴대전화 번호
              </th>
            </tr>
          </thead>

          <tbody>
            {contactList?.length > 0 ? (
              <>
                {contactList
                  ?.map((data, index) => {
                    return {
                      index,
                      data,
                    };
                  })
                  .map((item) => {
                    const { data, index } = item;
                    return (
                      <tr key={index}>
                        <td className="py-1.5 flex items-center justify-center border-r-0 border-t-0 border border-[#dddddd]">
                          {isBinded ? (
                            <XMarkIcon
                              onClick={() =>
                                handleDeleteBindedContact(data?.id)
                              }
                              className="text-[#e80000] w-[1.5rem] cursor-pointer"
                            />
                          ) : (
                            <input
                              checked={selectedContact?.includes(data?.id)}
                              type="checkbox"
                              className="w-5 h-5 cursor-pointer accent-primary-blue"
                              onChange={() => handleSelectContact(data?.id)}
                              // checked={selectedProducts?.includes(data?.id)}
                            />
                          )}
                        </td>

                        <td className="p-1.5 border border-[#dddddd]">
                          {contactList?.length - index}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {data?.affiliation}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {data?.name}
                        </td>
                        <td className="p-1.5 border border-[#dddddd]">
                          {data?.phone}
                        </td>
                      </tr>
                    );
                  })}

                {!isBinded &&
                  Array.from({ length: 5 - contactList?.length }).map(() => (
                    <tr className="h-8">
                      <td className="py-2 flex items-center justify-center border-r-0 border-t-0 border border-[#dddddd]">
                        <input
                          type="checkbox"
                          className="w-5 h-5 cursor-pointer accent-primary-blue"
                          // checked={selectedProducts?.includes(data?.id)}
                        />
                      </td>
                      <td className="p-2 border border-[#dddddd]"></td>
                      <td className="p-2 border border-[#dddddd]"></td>
                      <td className="p-2 border border-[#dddddd]"></td>
                      <td className="p-2 border border-[#dddddd]"></td>
                    </tr>
                  ))}
              </>
            ) : (
              <>
                {Array.from({ length: 5 }).map(() => (
                  <tr className="h-8">
                    <td className="p-2 border border-[#dddddd]">
                      {isCheckbox && <input type="checkbox" />}
                    </td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                    <td className="p-2 border border-[#dddddd]"></td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
